'use strict';

var AppDispatcher = require('../AppDispatcher'),
    StoreUtils = require('../utils/StoreUtils'),
    UserStore = require('../stores/UserStore'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    { createStore, mergeIntoBag } = StoreUtils;

var _activities = {};

var ActivityStore = createStore({
  get(id) {
    return _activities[id];
  }
});

ActivityStore.dispatchToken = AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([UserStore.dispatchToken, StampStore.dispatchToken, ZineStore.dispatchToken]);

  var action = payload.action,
      response = action.response,
      entities = response && response.entities,
      receivedActivities = entities && entities.activities;

  if (receivedActivities) {
    mergeIntoBag(_activities, receivedActivities);
    ActivityStore.emitChange();
  }
});

module.exports = ActivityStore;


/** WEBPACK FOOTER **
 ** ./stores/ActivityStore.js
 **/